import script from "./TokenInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./TokenInput.vue?vue&type=script&setup=true&lang=ts"

export default script